// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const ColumnEnlargeIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={14} viewBox="0 0 24 14" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="column-enlarge" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><g id="Group" transform="translate(-.955)"><path id="bg" fill="#FFF" d="M8.955 1h8v12h-8z" /><path id="Combined-Shape" fill="currentColor" d="M17.955 0v14h-10V0zm-2 2h-6v10h6zm4 9V3l5 4zm-14 0V3l-5 4z" /></g></g></svg>
))
